import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { Cards } from 'core/modules/Instore2/partials';

function LinkedCards({ offer }) {
  const { linkedCards } = offer;

  if (linkedCards.length === 1) {
    return <Cards offer={offer} shouldShowLinkedOnly />;
  }

  return (
    <div className="mn_instoreCards">
      <div className="mn_instoreCard mn_linkedCard">Linked to {linkedCards.length} cards</div>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><LinkedCards {...props} /></ComponentErrorBoundary>;
